import { fetchAPI } from '@/services/prismic';
import { camelize } from '@/scripts/camelize';

const getLocationById = `
  query getLocationById($id: String!) {
    allLocations(id: $id) {
      edges {
        node {
          _meta {
            uid
          }
          title
          city
          location_name
          description
          call_to_actions {
            call_to_action {
              ... on Call_to_action {
                title
                type
                style
                url
                open_in_another_page
              }
            }
          }
          images {
            image
          }
        }
      }
    }
  }
`

export const fetchLocationContent = async (id = '', previewData) => {
  const {
    allLocations: {
      edges: [{
        node: location,
      } = {}] = [],
    } = {},
  } = await fetchAPI(getLocationById, {
    previewData,
    variables: {
      id,
    },
  });

  return camelize(location);
};